import type { SVGProps } from 'react';

const SvgCropPortrait = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M19 3H5v18h14zm-2 16H7V5h10z" />
  </svg>
);
export default SvgCropPortrait;
